/* Presentation only: native product links and cart operations are preserved. */
(function () {
 'use strict';
 var zoom = document.createElement('div');
 zoom.className='enigma-cart-image-zoom';zoom.hidden=true;zoom.setAttribute('aria-hidden','true');
 document.body.appendChild(zoom);
 var scheduled=false;
 var fullRefresh=true,cartDirty=false,pendingBadges=new Set();
 var badgeSelector='[data-enigma-language-badge]';
 var cardSelector='.enigma-home-product-card,.item-product,.enigma-product-card-layout';
 function decorate() {
  scheduled=false;
  var writes=[];
  function setProperty(node,name,value){
   if(node.style.getPropertyValue(name)!==value)node.style.setProperty(name,value);
  }
  var images=fullRefresh||cartDirty?document.querySelectorAll('#desktop_cart .product-image'):[];
  var badges=fullRefresh?document.querySelectorAll(badgeSelector):Array.from(pendingBadges);
  fullRefresh=false;cartDirty=false;pendingBadges.clear();
  images.forEach(function(image){
   var link=image.closest('a');if(link&&!link.classList.contains('enigma-cart-image-link')){
    var width=image.getBoundingClientRect().width;
    if(width>0){writes.push(function(){setProperty(link,'--enigma-cart-thumb',width*.7+'px');link.classList.add('enigma-cart-image-link');});}
   }
  });
  badges.forEach(function(badge){
   if(!badge.isConnected)return;
   if(window.EnigmaPromoOffscreen?.blocked(badge)){pendingBadges.add(badge);return;}
   var card=badge.closest(cardSelector);
   var wishlist=card&&card.querySelector('[data-icon-wishlist],.btn-wishlist');
   if(wishlist){
    var wishRect=wishlist.getBoundingClientRect(),size=wishRect.width;
    if(size>0){
     writes.push(function(){setProperty(badge,'--enigma-language-size',size+'px');});
     var holder=badge.offsetParent;
     if(holder){
      var holderRect=holder.getBoundingClientRect();
      var inset=holderRect.right-(wishRect.left+size/2)-size*.4;
      writes.push(function(){setProperty(badge,'--enigma-language-inset',Math.max(0,inset)+'px');});
     }
    }
   }
  });
  // Measure all cards before applying styles; unchanged values need no write.
  writes.forEach(function(write){write();});
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(decorate);}}
 function inspect(node,inserted){
  if(!node||node.nodeType!==1)return;
  if(node.closest('#desktop_cart')||(inserted&&(node.matches('#desktop_cart')||node.querySelector('#desktop_cart'))))cartDirty=true;
  var card=node.closest(cardSelector);
  if(card)card.querySelectorAll(badgeSelector).forEach(function(badge){pendingBadges.add(badge);});
  if(inserted){
   if(node.matches(badgeSelector))pendingBadges.add(node);
   node.querySelectorAll(badgeSelector).forEach(function(badge){pendingBadges.add(badge);});
  }
 }
 new MutationObserver(function(records){
  records.forEach(function(record){
   // Filtering changes the geometry of every card in this rail.
   if(record.type==='attributes'){
    var rail=record.target.closest('[data-eh-rail]');
    if(rail)rail.querySelectorAll(badgeSelector).forEach(function(badge){pendingBadges.add(badge);});
    return;
   }
   inspect(record.target,false);
   record.addedNodes.forEach(function(node){inspect(node,true);});
  });
  if(cartDirty||pendingBadges.size)schedule();
 }).observe(document.body,{childList:true,attributes:true,attributeFilter:['hidden'],subtree:true});
 function show(link){
  var image=link.querySelector('.product-image');if(!image)return;
  var rect=link.getBoundingClientRect(),large=document.createElement('img');
  large.src=image.currentSrc||image.src;large.alt='';zoom.replaceChildren(large);
  zoom.style.left=Math.max(8,Math.min(innerWidth-196,rect.left-194))+'px';
  zoom.style.top=Math.max(8,Math.min(innerHeight-270,rect.top))+'px';zoom.hidden=false;
 }
 document.addEventListener('pointerover',function(e){var link=e.target.closest('.enigma-cart-image-link');if(link&&matchMedia('(hover:hover)').matches)show(link);});
 document.addEventListener('pointerout',function(e){if(e.target.closest('.enigma-cart-image-link'))zoom.hidden=true;});
 document.addEventListener('focusin',function(e){var link=e.target.closest('.enigma-cart-image-link');if(link)show(link);});
 document.addEventListener('focusout',function(){zoom.hidden=true;});
 document.addEventListener('keydown',function(e){if(e.key==='Escape')zoom.hidden=true;});
 document.addEventListener('scroll',function(){zoom.hidden=true;},true);
 window.addEventListener('resize',function(){zoom.hidden=true;fullRefresh=true;schedule();});
 document.addEventListener('enigma:promo-layout-resume',function(event){
  event.detail.panel.querySelectorAll(badgeSelector).forEach(function(badge){pendingBadges.add(badge);});schedule();
 });
 decorate();
})();
